import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-8 md:gap-6" }
const _hoisted_2 = {
  id: "memberBenefits",
  class: "scroll-mt-[60px] md:scroll-mt-4"
}

import { ISitecoreFormGenericInput } from '@/interfaces';
import { onMounted, ref } from 'vue';
import { getFormInput } from '@/utils/form-input-helper';
import { useAccountStore } from '@/store';
import PromoCardMiniList from '@/components/PromoCardMini/PromoCardMiniList.vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import Divider from '@/components/Divider/Divider.vue';
import { useI18n } from 'vue-i18n';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberBenefits',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

const accountStore = useAccountStore();
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;
const membershipBenefits = getFormInput(
  props.content,
  accountStore.identityDetails?.membershipLoyalty?.toLowerCase() + 'MemberPromoCardMiniList'
);
const membershipBenefitsDisclaimer = getFormInput(
  props.content,
  accountStore.identityDetails?.membershipLoyalty?.toLowerCase() + 'MemberDisclaimer'
);

const membershipLoyaltyLevel = ref<string>(accountStore.identityDetails?.membershipLoyalty ?? '');

const membershipPanelTitle = {
  ...getFormInput(props.content, 'memberPanelTitle'),
  title: {
    value: `<span class='text-member-${membershipLoyaltyLevel?.value.toLowerCase()}'>${membershipLoyaltyLevel.value} member</span> benefits<sup>†</sup>`,
  },
};

onMounted(() => {
  pushAnalytics();
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PanelTitle, _mergeProps(membershipPanelTitle, { isTitleRichText: true }), null, 16)
      ]),
      _createVNode(PromoCardMiniList, {
        bindings: _unref(membershipBenefits),
        promoCards: _unref(membershipBenefits).fields,
        heading: _unref(membershipBenefits).heading,
        cardLayout: _unref(membershipBenefits).cardLayout,
        maxItemsToShow: _unref(membershipBenefits).maxItemsToShow
      }, null, 8, ["bindings", "promoCards", "heading", "cardLayout", "maxItemsToShow"]),
      _createVNode(_unref(RichText), {
        class: "racq-max-w-xl5",
        field: _unref(membershipBenefitsDisclaimer).label
      }, null, 8, ["field"]),
      _createVNode(Divider, { outerClass: "!my-12 mb-20" })
    ])
  ]))
}
}

})